import { SVGProps } from "react";

const StopwatchIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.3141 38.5557C112.221 33.5819 134.422 28.5053 151.506 39.8281C168.063 50.8022 165.957 74.3538 173.82 92.5766C184.397 117.089 216.665 139.25 204.719 163.152C192.899 186.803 156.56 177.666 130.184 179.888C110.593 181.539 89.524 185.876 73.746 174.187C58.932 163.211 60.9072 141.878 55.2266 124.354C48.9549 105.006 31.205 86.5512 39.2816 67.8669C47.6031 48.6159 71.9407 43.6459 92.3141 38.5557Z"
        fill="url(#paint0_linear_16741_122688)"
      />
      <path
        opacity="0.9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.3141 38.5557C112.221 33.5819 134.422 28.5053 151.506 39.8281C168.063 50.8022 165.957 74.3538 173.82 92.5766C184.397 117.089 216.665 139.25 204.719 163.152C192.899 186.803 156.56 177.666 130.184 179.888C110.593 181.539 89.524 185.876 73.746 174.187C58.932 163.211 60.9072 141.878 55.2266 124.354C48.9549 105.006 31.205 86.5512 39.2816 67.8669C47.6031 48.6159 71.9407 43.6459 92.3141 38.5557Z"
        fill="white"
      />
      <path
        d="M120.001 205.227C171.4 205.227 213.068 202.794 213.068 199.793C213.068 196.792 171.4 194.359 120.001 194.359C68.6012 194.359 26.9336 196.792 26.9336 199.793C26.9336 202.794 68.6012 205.227 120.001 205.227Z"
        fill="#F5F5F5"
      />
      <path
        d="M120.001 86C144.67 86.0002 164.667 105.998 164.667 130.667C164.667 155.335 144.669 175.333 120.001 175.333C95.3324 175.333 75.3342 155.336 75.334 130.667C75.334 105.998 95.3323 86 120.001 86Z"
        fill="white"
        stroke="#71717A"
        strokeWidth="4"
      />
      <path
        d="M108.334 60.668H131.667M120.001 130.668L137.501 113.168"
        stroke="#71717A"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_16741_122688"
          x1="100.996"
          y1="36.0237"
          x2="142.061"
          y2="189.284"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD9AB0" />
          <stop offset="1" stopColor="#A982CF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StopwatchIcon;
